/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const HostedResourceContainer = styled.div`
  height: 100%;
  width: 100%;

  > iframe {
    border-style: none;
  }
`;

export const ModalWrapper = styled.div<{
  modalHeight: string | number;
  modalMinHeight?: string | number;
}>`
  ${props => `
      height: ${props.modalHeight};
      min-height: ${props.modalMinHeight ?? props.modalHeight};
  `}
  padding: 24px 0;
  border-radius: ${borderRadius()}px;
  background: ${token('elevation.surface.overlay', colors.N0)};
  iframe {
    border-radius: ${borderRadius()}px;
  }
`;
